import { useDataProvider } from "react-admin";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

import BackButtonToolbar from "features/BackButtonToolbar";
import { SpecialistsCandidacyStates } from "utils/constants";
import { specialistRequests } from "api/specialistApi";

import ConfirmModal from "server/components/Modals/ConfirmModal";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import ReturnForCorrectionModal from "./ReturnForCorrectionModal";

const CampaignApplicationDetailsActions = ({ getDetails, details, campaignId, applicationId, notify }) => {
  const dataProvider = useDataProvider();

  const isAvaliableForCorrection = details?.statusId === SpecialistsCandidacyStates.Submitted;

  const changeState = async statusId => {
    return await dataProvider.customRequest(
      specialistRequests.updateCampaignApplicationStatus(campaignId, applicationId),
      { statusId: statusId },
      "PUT",
    );
  };
  return (
    <BackButtonToolbar
      additionalButton={
        <>
          {isAvaliableForCorrection && (
            <SecuredComponent permission={permissions.canReturnSpecialistsCampaignApplicationsForCorrection}>
              <ReturnForCorrectionModal
                item={details}
                getDetails={getDetails}
              />
            </SecuredComponent>
          )}

          {isAvaliableForCorrection && (
            <SecuredComponent permission={permissions.canChangeSpecialistsCampaignApplicationsStatuses}>
              <ConfirmModal
                startIcon={<ThumbDownIcon />}
                titleButton={"Откажи Кандидатура"}
                btnStyle={{ background: "#9D1B53" }}
                titleContent="Отказ на кандидатура"
                onConfirm={async () => {
                  await changeState(SpecialistsCandidacyStates.Rejected);
                  getDetails();
                  notify("Кандидатурата е отказана успешно", { type: "success" });
                }}
                message="Сигурен ли сте, че искате да откажете тази кандидатура?"
              />
            </SecuredComponent>
          )}
          {isAvaliableForCorrection && (
            <SecuredComponent permission={permissions.canChangeSpecialistsCampaignApplicationsStatuses}>
              <ConfirmModal
                titleButton={"Одобри Кандидатура"}
                titleContent="Одобряване на кандидатура"
                onConfirm={async () => {
                  await changeState(SpecialistsCandidacyStates.Approved);
                  getDetails();
                  notify("Кандидатурата е одобрена успешно", { type: "success" });
                }}
                message="Сигурен ли сте, че искате да одобрите тази кандидатура?"
              />
            </SecuredComponent>
          )}
        </>
      }
    />
  );
};
export default CampaignApplicationDetailsActions;
